import axios from 'axios';
import store from "../store/store.js";

export default () => {
    const api = axios.create({
        baseURL: 'http://localhost:8000/',
        headers: {"Content-Type": "application/json"},
    });

    // request setting
    api.interceptors.request.use((config) => {
        config.headers.Authorization = `Bearer ${store.getters.getToken}`;
        config.headers.Accept = '*/*';
        return config;
    });

    // response error handling
    api.interceptors.response.use(
        (res) => {
            return res;
        },
        async (err) => {
            const originalConfig = err.config;
            if (originalConfig.url === "auth/refresh" && err.response) {
                store.dispatch("logOut");
                return Promise.reject(err);
            }
            if (originalConfig.url !== "auth/login" && err.response) {
            // Access Token was expired
                if (err.response.status === 401 && !originalConfig._retry) {
                    originalConfig._retry = true;

                    try {
                        const rs = await api.post("auth/refresh", {
                            refresh_token: store.getters.getRefreshToken,
                        });

                        store.dispatch('updateTokensFromRefresh', rs);

                        return api(originalConfig);
                    } catch (_error) {
                        return Promise.reject(_error);
                    }
                }
            }
            if (err.response) {
                let errorMessage = err.response.data;
                errorMessage.responseStatus = err.response.status;
                return errorMessage;
            }

            return Promise.reject(err);
        }
    );
    // return API object
    return api;
};
